import { cn } from '@/utils/styles';

interface BoostTagProps {
  className?: string;
  children: React.ReactNode;
}

function BoostTag({ children, className }: BoostTagProps) {
  return (
    <div
      className={cn(
        'py-[2.5px] px-1.5 rounded text-xs font-medium text-white scale-75 sm:scale-100 sm:mr-2 origin-left',
        className,
      )}
      style={{
        background: 'linear-gradient(91.59deg, #FF7613 0%, #E99330 100%)',
      }}
    >
      {children}
    </div>
  );
}

export default BoostTag;
